// Daily streaks, kept on this device (works for anonymous players).
const KEY = "cv_daily_streak";
export const CHART_KEY = "cv_chart_streak";
export const SPORT_KEY = "cv_sport_streak";

const dayDiff = (a, b) => Math.round((Date.parse(b + "T00:00:00Z") - Date.parse(a + "T00:00:00Z")) / 86400000);

export const readStreak = (key = KEY) => {
  try {
    const s = JSON.parse(localStorage.getItem(typeof key === "string" ? key : KEY)) || {};
    const today = new Date().toISOString().slice(0, 10);
    const alive = s.last && dayDiff(s.last, today) <= 1;
    return { count: alive ? s.count || 0 : 0, best: s.best || 0, last: s.last, playedToday: s.last === today };
  } catch { return { count: 0, best: 0 }; }
};

export const recordDailyPlay = (key = KEY) => {
  const today = new Date().toISOString().slice(0, 10);
  const s = readStreak(key);
  if (s.playedToday) return s;
  const count = s.last && dayDiff(s.last, today) === 1 ? s.count + 1 : 1;
  const next = { last: today, count, best: Math.max(count, s.best || 0) };
  localStorage.setItem(key, JSON.stringify(next));
  return { ...next, playedToday: true };
};

export const MILESTONES = [7, 30, 100];

export const milestoneFor = (count) => {
  const earned = [...MILESTONES].reverse().find((m) => count >= m) || 0;
  const next = MILESTONES.find((m) => count < m) || 0;
  return { earned, next, justHit: MILESTONES.includes(count), toNext: next ? next - count : 0 };
};
